// @flow
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import {
  toggleSearchResultsDialog,
  setGeometryFormat,
} from 'actions/searchResultsDialog';
import { setContactFields, submitContactData } from 'actions/contactCard';
import { showErrorMessage } from 'actions/errorMessage';

import SearchResultsDialog from './SearchResultsDialog';

const mapStateToProps = ({
  browser,
  search,
  searchResultsDialog,
  contactCard,
  filters: { dateRange },
  flags: { hasSubscription },
}) => ({
  ...searchResultsDialog,
  contactCardData: contactCard,
  search,
  browser,
  dateRange,
  hasSubscription,
});

const mapDispatchToProps = {
  toggleSearchResultsDialog,
  setGeometryFormat,
  setContactFields,
  submitContactData,
  pushRoute: push,
  showErrorMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultsDialog);



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/index.js